module.exports = __webpack_public_path__ + "media/images/icons/material/invisible-3bb213a980343a380118ebe51e5db9f3.svg";